"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuLinks = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _helpers = require("../helpers");

var _useHeaderMenu = require("../useHeaderMenu");

var _UiComponents = require("./UiComponents");

var _Icons = require("./Icons");

var _core = require("@emotion/core");
/* eslint-disable import/namespace */


var propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node
} : {};

var SubMenuLinks = function SubMenuLinks(_ref) {
  var children = _ref.children;

  var _ref2 = (0, _useHeaderMenu.useHeaderMenu)(),
      _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[0],
      domain = _ref3$.domain,
      isOpenSubMenu = _ref3$.isOpenSubMenu,
      activeItem = _ref3$.activeItem,
      isMobile = _ref3$.isMobile,
      currentConfig = _ref3$.currentConfig,
      _ref3$2 = _ref3[1],
      toggleOpenSubMenu = _ref3$2.toggleOpenSubMenu,
      handleDispatchSubMenuEvents = _ref3$2.handleDispatchSubMenuEvents;

  var colors = currentConfig.colors,
      links = currentConfig.links;
  var isValidActiveItem = links.some(function (_ref4) {
    var id = _ref4.id;
    return id === activeItem;
  });

  var isActiveProps = function isActiveProps(id) {
    var activeProps = {
      as: 'span',
      isActive: true
    };
    var commonProps = {
      as: 'a'
    };
    return id === activeItem ? activeProps : commonProps;
  };

  var commonLinkProps = function commonLinkProps(_ref5) {
    var id = _ref5.id,
        link = _ref5.link,
        label = _ref5.label;
    var beginningURL = (0, _helpers.isAbsoluteURL)(link) ? '' : domain;
    return _objectSpread({
      href: "".concat(beginningURL).concat(link),
      fontColor: colors.font,
      activeColor: colors.active,
      onClick: function onClick() {
        return handleDispatchSubMenuEvents({
          action: "inbound links | ".concat(label.toLowerCase()),
          label: "".concat(beginningURL).concat(link)
        });
      }
    }, isActiveProps(id));
  };

  var ArrowItem = isOpenSubMenu ? _Icons.ArrowTop : _Icons.ArrowDown;
  return (0, _core.jsx)(_UiComponents.Container.SubMenuLinks, {
    marginTop: 0
  }, links == null ? void 0 : links.map(function (linkItem, index) {
    var isFirst = index === 0;

    var linkItemProps = _objectSpread({
      childrenCount: links.length
    }, commonLinkProps(linkItem));

    var isActiveLinkItem = linkItemProps.isActive;
    var isHighlightItem = isMobile && (isActiveLinkItem || !isValidActiveItem && isFirst);
    return (0, _core.jsx)(_UiComponents.Container.SubMenuLinkItem, {
      as: "li",
      key: linkItem.id,
      isActive: isActiveLinkItem
    }, (0, _core.jsx)(_UiComponents.Typo.SubItem, linkItemProps, linkItem.label), isHighlightItem && (0, _core.jsx)(_UiComponents.Container.SubMenuActions, {
      hasChildren: !!children
    }, (0, _core.jsx)(_UiComponents.Container.SubMenuToggle, {
      as: "button",
      "aria-label": "Toggle Submenu",
      onClick: (0, _helpers.preventDefaults)(toggleOpenSubMenu)
    }, (0, _core.jsx)(ArrowItem, {
      "aria-hidden": true
    })), children && (0, _core.jsx)(_UiComponents.Layout.Flex, {
      padding: 0,
      alignItems: "center"
    }, (0, _core.jsx)(_UiComponents.Container.SubMenuChildren, null, (0, _core.jsx)(_UiComponents.Layout.Flex, {
      justifyContent: "flex-end",
      padding: 0
    }, children)))));
  }));
};

exports.SubMenuLinks = SubMenuLinks;
process.env.NODE_ENV !== "production" ? SubMenuLinks.propTypes = propTypes : void 0;
SubMenuLinks.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SubMenuLinks",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};